import { memo } from "react"
import OrganizationLogo from "../OrganizationLogo"
import StaffSelector from "./components/StaffSelector"
import StaffMenu from "./components/StaffMenu"

// Create a regular function component
function StaffSidebar() {
  return (
    <div>
      <OrganizationLogo />
      <StaffSelector />
      <StaffMenu />
    </div>
  )
}

// Export the component wrapped in React.memo to prevent unnecessary renders
export default memo(StaffSidebar)
